import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { AcquirerGridRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const acquirerGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  rowClass: 'cursor-pointer',
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No acquirers match the current filters.</span>',
} satisfies GridOptions<AcquirerGridRow>;
